export const PROMPT_SNIPPET_CHAT_TYPES = ["Client", "Prospect", "Meeting", "Book"] as const
export type PromptSnippetChatType = (typeof PROMPT_SNIPPET_CHAT_TYPES)[number]

export interface PromptSnippet {
  id: string | null
  title: string
  content: string
  icon: string
  color: string
  chat_type: PromptSnippetChatType
  key: string
  system_key: string | null
  book_ids?: string[]
  can_delete?: boolean
  can_update?: boolean
  book_id: string | null
  book_name: string | null
  book_initials: string | null
  created_at: string | null
  updated_at: string | null
  created_by_id: string | null
  created_by_name: string | null
  created_by_profile_picture_url: string | null
}

export interface PromptSnippetInput {
  book_ids?: string[]
  title: string
  content: string
  icon: string
  color: string
  chat_type: PromptSnippetChatType
}
